var styles = {"message":"styles_message__2cZYQ p2","list-title":"styles_list-title__36uOo mb1","listTitle":"styles_list-title__36uOo mb1","list":"styles_list__c0SeX","recap":"styles_recap__3zY6p mt1"};

export default styles;
//# sourceMappingURL=styles.css.js.map
